import axios from "axios";
import authHeader from "./auth-header";

const base = () => `${process.env.REACT_APP_API_Link}/finance-v2`;

const FinanceV2Services = {
  getSetupStatus: (branchId) =>
    axios.get(`${base()}/setup/status`, {
      params: { branch_id: branchId },
      headers: authHeader(),
    }),

  getWizardOptions: (branchId) =>
    axios.get(`${base()}/setup/wizard-options`, {
      params: { branch_id: branchId },
      headers: authHeader(),
    }),

  saveCompany: (payload) =>
    axios.post(`${base()}/setup/company`, payload, { headers: authHeader() }),

  seedChart: (branchId) =>
    axios.post(
      `${base()}/setup/seed-chart`,
      {},
      { params: { branch_id: branchId }, headers: authHeader() }
    ),

  saveOpeningBalances: (payload) =>
    axios.post(`${base()}/setup/opening-balances`, payload, {
      headers: authHeader(),
    }),

  completeSetup: (branchId) =>
    axios.post(
      `${base()}/setup/complete`,
      {},
      { params: { branch_id: branchId }, headers: authHeader() }
    ),

  getDashboard: (branchId) =>
    axios.get(`${base()}/reports/dashboard`, {
      params: { branch_id: branchId },
      headers: authHeader(),
    }),

  getModuleStatus: (branchId) =>
    axios.get(`${base()}/import/module-status`, {
      params: { branch_id: branchId },
      headers: authHeader(),
    }),

  importAll: (params) =>
    axios.post(`${base()}/import/all`, {}, { params, headers: authHeader() }),

  importExpenses: (params) =>
    axios.post(`${base()}/import/expenses`, {}, { params, headers: authHeader() }),

  importCharity: (params) =>
    axios.post(`${base()}/import/charity`, {}, { params, headers: authHeader() }),

  importPayroll: (params) =>
    axios.post(`${base()}/import/payroll`, {}, { params, headers: authHeader() }),

  importVostro: (params) =>
    axios.post(`${base()}/import/vostro-expenses`, {}, { params, headers: authHeader() }),

  getAccountsTree: (branchId) =>
    axios.get(`${base()}/accounts`, {
      params: { branch_id: branchId },
      headers: authHeader(),
    }),

  getAccountsList: (branchId) =>
    axios.get(`${base()}/accounts/list`, {
      params: { branch_id: branchId },
      headers: authHeader(),
    }),

  getAccountTypes: () =>
    axios.get(`${base()}/accounts/types`, { headers: authHeader() }),

  createAccount: (payload) =>
    axios.post(`${base()}/accounts`, payload, { headers: authHeader() }),

  recordExpense: (payload) =>
    axios.post(`${base()}/transactions/expense`, payload, { headers: authHeader() }),

  recordTransfer: (payload) =>
    axios.post(`${base()}/transactions/transfer`, payload, { headers: authHeader() }),

  recordCharity: (payload) =>
    axios.post(`${base()}/transactions/charity`, payload, { headers: authHeader() }),

  recordLiabilityPayment: (payload) =>
    axios.post(`${base()}/transactions/liability-payment`, payload, {
      headers: authHeader(),
    }),

  backfillLegacyExpenses: (params) =>
    axios.post(`${base()}/transactions/backfill-legacy-expenses`, {}, {
      params,
      headers: authHeader(),
    }),

  saveMappings: (payload) =>
    axios.post(`${base()}/mappings`, payload, { headers: authHeader() }),

  seedMappingDefaults: (branchId) =>
    axios.post(
      `${base()}/mappings/seed-defaults`,
      {},
      { params: { branch_id: branchId }, headers: authHeader() }
    ),

  seedPaymentMethodMappings: (branchId) =>
    axios.post(
      `${base()}/mappings/seed-payment-methods`,
      {},
      { params: { branch_id: branchId }, headers: authHeader() }
    ),

  getMappings: (branchId) =>
    axios.get(`${base()}/mappings`, {
      params: { branch_id: branchId },
      headers: authHeader(),
    }),

  getJournals: (params) =>
    axios.get(`${base()}/journals`, { params, headers: authHeader() }),

  createJournal: (payload) =>
    axios.post(`${base()}/journals`, payload, { headers: authHeader() }),

  voidJournal: (id, payload = {}) =>
    axios.post(`${base()}/journals/${id}/void`, payload, { headers: authHeader() }),

  getJournal: (id, branchId) =>
    axios.get(`${base()}/journals/${id}`, {
      params: { branch_id: branchId },
      headers: authHeader(),
    }),

  updateAccount: (id, payload) =>
    axios.put(`${base()}/accounts/${id}`, payload, { headers: authHeader() }),

  importBankLedger: (params) =>
    axios.post(`${base()}/import/bank-ledger`, {}, { params, headers: authHeader() }),

  importPettyCash: (params) =>
    axios.post(`${base()}/import/petty-cash`, {}, { params, headers: authHeader() }),

  importLiabilityLedger: (params) =>
    axios.post(`${base()}/import/liability-ledger`, {}, { params, headers: authHeader() }),

  getTrialBalance: (params) =>
    axios.get(`${base()}/reports/trial-balance`, {
      params,
      headers: authHeader(),
    }),

  getProfitAndLoss: (params) =>
    axios.get(`${base()}/reports/profit-and-loss`, {
      params,
      headers: authHeader(),
    }),

  getBalanceSheet: (params) =>
    axios.get(`${base()}/reports/balance-sheet`, {
      params,
      headers: authHeader(),
    }),

  getGeneralLedger: (accountId, params) =>
    axios.get(`${base()}/reports/general-ledger/${accountId}`, {
      params,
      headers: authHeader(),
    }),

  getAccountsReceivable: (params) =>
    axios.get(`${base()}/reports/accounts-receivable`, {
      params,
      headers: authHeader(),
    }),

  getBankUncleared: (accountId, params) =>
    axios.get(`${base()}/bank/${accountId}/uncleared`, {
      params,
      headers: authHeader(),
    }),

  getBankSummary: (accountId, params) =>
    axios.get(`${base()}/bank/${accountId}/summary`, {
      params,
      headers: authHeader(),
    }),

  clearBankLines: (payload) =>
    axios.post(`${base()}/bank/clear`, payload, { headers: authHeader() }),

  getFiscalPeriods: (branchId) =>
    axios.get(`${base()}/fiscal/periods`, {
      params: { branch_id: branchId },
      headers: authHeader(),
    }),

  closeFiscalPeriod: (periodId) =>
    axios.post(`${base()}/fiscal/periods/${periodId}/close`, {}, {
      headers: authHeader(),
    }),

  getBackfillStats: (params) =>
    axios.get(`${base()}/sync/backfill-stats`, { params, headers: authHeader() }),

  backfillSales: (params) =>
    axios.post(`${base()}/sync/backfill`, {}, { params, headers: authHeader() }),

  getSyncLog: (params) =>
    axios.get(`${base()}/sync/log`, { params, headers: authHeader() }),

  getHealthCheck: (branchId) =>
    axios.get(`${base()}/reports/health-check`, {
      params: { branch_id: branchId },
      headers: authHeader(),
    }),

  retryAllFailed: (params) =>
    axios.post(`${base()}/import/retry-all-failed`, {}, { params, headers: authHeader() }),

  repairPayrollSyncLog: (branchId) =>
    axios.post(
      `${base()}/import/repair-payroll-sync-log`,
      {},
      { params: { branch_id: branchId }, headers: authHeader() }
    ),

  getVendors: (branchId) =>
    axios.get(`${base()}/vendors`, { params: { branch_id: branchId }, headers: authHeader() }),

  createVendor: (payload) =>
    axios.post(`${base()}/vendors`, payload, { headers: authHeader() }),

  importVendorsFromExpenses: (branchId) =>
    axios.post(
      `${base()}/vendors/import-from-expenses`,
      {},
      { params: { branch_id: branchId }, headers: authHeader() }
    ),

  getAuditLog: (branchId, params = {}) =>
    axios.get(`${base()}/audit-log`, {
      params: { branch_id: branchId, ...params },
      headers: authHeader(),
    }),
};

export default FinanceV2Services;
